var _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreloaderLogoCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.777832,
    y: 1.15015,
    width: 0.772947,
    height: 19.3237,
    transform: "rotate(-45 0.777832 1.15015)",
    fill: "#CFD3DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4418,
    y: 0.60376,
    width: 0.772947,
    height: 19.3237,
    transform: "rotate(45 14.4418 0.60376)",
    fill: "#CFD3DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloaderLogoCross);
export default __webpack_public_path__ + "static/media/preloader_logo_cross.6a220f0436ab88fdbd3a207e1ee505d9.svg";
export { ForwardRef as ReactComponent };